import type { WReferenceLinkingToUrlContent } from "@/lib/api/cms-window-content";
import styles from "./WReferenceLinkingToUrlGreyBack.module.css";

/**
 * WReferenceLinkingToUrlGreyBack — variant renderera dla `w_reference_linking_to_url`.
 *
 * Identyczne dane wejściowe i markup co `WReferenceLinkingToUrl` (default),
 * ale inna typografia tytułu (uppercase + letter-spacing + accent border) +
 * subtelne grey background sekcji. Używany jako test referencyjny mechanizmu
 * `WINDOW_AREA_VARIANTS` — pierwszy variant zarejestrowany dla pary
 * (`w_reference_linking_to_url`, `heroSmallTop`).
 *
 * Aby reuse'ować ten sam variant w innym obszarze — wystarczy dopisać kolejny
 * entry w `areaVariants.ts` (bez duplikacji komponentu).
 */
export default function WReferenceLinkingToUrlGreyBack({
  content,
}: WReferenceLinkingToUrlGreyBackProps) {
  if (!content) return null;

  const { title, config } = content;
  if (!title) return null;

  const titleNode = <span dangerouslySetInnerHTML={{ __html: title }} />;

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>
        {config.list_url ? (
          <a href={config.list_url} className={styles.link}>
            {titleNode}
          </a>
        ) : (
          titleNode
        )}
      </h2>
      {config.description && (
        <p
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: config.description }}
        />
      )}
    </div>
  );
}

export type WReferenceLinkingToUrlGreyBackProps = {
  content: WReferenceLinkingToUrlContent | null;
};
